<template>
  <div class="container">
    <div class="col-md-8 mx-auto">
      <div class="form-inline mb-3">
        <div class="form-group mr-2">
          <label for="from" class="mr-2">From</label>
          <input
            type="time"
            id="from"
            class="form-control"
            v-model="newClip.from"
            :max="formattedMaxTime"
            step="1"
          />
        </div>
        <div class="form-group mr-2">
          <label for="to" class="mr-2">To</label>
          <input
            type="time"
            id="to"
            class="form-control"
            v-model="newClip.to"
            :max="formattedMaxTime"
            step="1"
          />
        </div>
        <button class="btn btn-primary" @click="addClip" :disabled="!canAddClip">
          クリップを追加
        </button>
      </div>

      <ul class="list-group">
        <li v-for="(clip, index) in clips.items" :key="index" class="list-group-item d-flex justify-content-between align-items-center">
          <span>
            <strong>ID</strong>:
            <span v-if="clip.transcoded">
              <a :href="clip.links.show">{{ clip.id }}</a>
            </span>
            <span v-else>{{ clip.id }}</span>
            - <strong>From</strong>: {{ clip.from }} - <strong>To</strong>: {{ clip.to }}
            - <span v-if="clip.transcoded" class="badge badge-danger mr-1">{{ __('Ready') }}</span>
            <span v-else class="badge badge-secondary mr-1">{{ __('Processing') }}</span>
            - <strong>{{ __('clip.created_at') }}</strong>: {{ clip.created_at }}
          </span>
          <button class="btn btn-danger btn-sm" @click="confirmRemoveClip(index)">削除</button>
        </li>
      </ul>

      <button class="btn btn-success mt-3 btn-block" @click="submitClips">クリップ作成</button>
      <input type="hidden" :value="clips" name="clips" />
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    videoDuration: { type: Number, required: true },
    videoId: { type: Number, required: true },
    endpoint: { type: String, required: true },
    endpoint_clips: { type: String, required: true },
  },
  data() {
    return {
      newClip: {
        from: "00:00:00",
        to: "00:00:00",
        new: true,
      },
      clips: { items: [] },
    };
  },
  computed: {
    formattedMaxTime() {
      return this.secondsToTime(this.videoDuration);
    },
    canAddClip() {
      const { from, to } = this.newClip;
      return from && to && from < to && this.timeToSeconds(to) <= this.videoDuration;
    },
  },
  methods: {
    async fetchClips() {
      try {
        const response = await axios.get(this.endpoint_clips, { params: { videoId: this.videoId } });
        this.clips = response.data || { items: [] };
      } catch (error) {
        console.error("クリップ取得エラー:", error.response || error);
      }
    },
    addClip() {
      this.clips.items.push({ ...this.newClip });
      this.newClip.from = "00:00:00";
      this.newClip.to = "00:00:00";
      this.newClip.new = true;
    },
    confirmRemoveClip(index) {
      if (confirm(this.__("I really delete this?"))) {
        const targetClip = this.clips.items[index];
        if (targetClip.links && targetClip.links.remove) {
          window.location.href = targetClip.links.remove;
        } else {
          this.clips.items.splice(index, 1);
        }
      }
    },
    async submitClips() {
      const filteredClips = this.clips.items.filter((clip) => clip.new === true);
      try {
        await axios.post(this.endpoint, { videoId: this.videoId, clips: filteredClips });
        window.alert(this.__("Created a clip."));
        this.fetchClips();
      } catch (error) {
        console.error("送信エラー:", error.response || error);
      }
    },
    secondsToTime(seconds) {
      const hrs = Math.floor(seconds / 3600).toString().padStart(2, "0");
      const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, "0");
      const secs = (seconds % 60).toString().padStart(2, "0");
      return `${hrs}:${mins}:${secs}`;
    },
    timeToSeconds(time) {
      const [hrs, mins, secs] = time.split(":").map(Number);
      return hrs * 3600 + mins * 60 + secs;
    },
  },
  mounted() {
    this.fetchClips();
  },
};
</script>
